/* eslint-disable @typescript-eslint/no-explicit-any */

export const randomNum = (limit: number, offset = 0): number =>
  Math.random() * limit + offset;

export const roundTo = (num: number, multiple = 5): number =>
  Math.round(num / multiple) * multiple;

export const randomFromArr = (arr: unknown[]): unknown =>
  arr[Math.floor(arr.length * Math.random())];

export const mapRange = (
  num: number,
  in_min: number,
  in_max: number,
  out_min: number,
  out_max: number
): number => {
  return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

export const secondsToTime = (input: number): string => {
  const minutes = Math.floor(input / 60);
  const seconds = Math.floor(input - minutes * 60);

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const timeout = (time: number): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};

export const clamp = (num: number, min: number, max: number): number => {
  return Math.min(Math.max(num, min), max);
};

export const truncateWords = (
  str: string,
  numWords = 10,
  suffix = "..."
): string => {
  const words = str.split(" ");

  if (words.length > numWords) {
    return `${words.splice(0, numWords).join(" ")}${suffix}`;
  }

  return words.join(" ");
};
